// Inventory API — in the deployed image the SPA is same-origin with the API,
// so VITE_API_URL is "/api"; the Vite dev server proxies /api to the local API
// (see vite.config.js), so the same relative URL works in dev.
export const API_URL = import.meta.env.VITE_API_URL ?? '/api'
// Mission Control (the mesh auth service) — used only for sign-in.
export const MC_URL = import.meta.env.VITE_MC_URL ?? 'http://localhost:8050'
// Google OAuth client id — the SAME client Mission Control's web app uses.
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID

// Fail loudly in dev when required config is missing — a silent undefined
// renders a dead sign-in button with no explanation.
if (import.meta.env.DEV) {
  const missing = []
  if (!import.meta.env.VITE_MC_URL) missing.push('VITE_MC_URL')
  if (!import.meta.env.VITE_GOOGLE_CLIENT_ID) missing.push('VITE_GOOGLE_CLIENT_ID')
  if (missing.length > 0) {
    throw new Error(
      `Missing required env var(s): ${missing.join(', ')} — copy web/.env.example to web/.env and fill them in.`,
    )
  }
}
